export default "__VITE_ASSET__K8c4of0D__"